import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';

const animationDuration = 201;

const Container = styled.div<{ isVisible: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: calc(${theme.grid?.maxWidth} - 2 * ${theme.spacings?.[4].rem});
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition: opacity ${animationDuration}ms, visibility ${animationDuration}ms;

  ${breakpoint('md')`
    top: unset;
  `}

  ${breakpoint('lg')`
    max-width: calc(${theme.grid?.maxWidth} - 2 * ${theme.spacings?.[5].rem});  
    top: unset;
  `}
`;

const Box = styled.div`
  display: flex;
  width: 100vw;
  min-height: calc(100vh - 140px);
  margin-left: auto;
  background-color: ${theme.colors.primary.white};
  box-shadow: 0px 4px 4px ${theme.colors.neutrals.transparentGrays[6]};

  ${breakpoint('md')`
        min-height: unset;
        width: calc(100% - (264px + ${theme.spacings?.[4].rem}));
    `}

  ${breakpoint('lg')`
        width: calc(100% - (264px + ${theme.spacings?.[5].rem}));
    `}
    ${breakpoint('xl')` 
        min-height: unset;
        width: calc(100% - 264px);
    `}

    & > * {
    width: 100%;
  }
`;

export const SearchBox: React.FC<
  PropsWithChildren<{ isExpanded: boolean; className?: string }>
> = ({ isExpanded, className, children }) => {
  return (
    <Container className={className} isVisible={isExpanded}>
      <Box>{children}</Box>
    </Container>
  );
};
